import { render, staticRenderFns } from "./RiskDisclaimer.vue?vue&type=template&id=6f0cb57e"
import script from "./RiskDisclaimer.vue?vue&type=script&lang=ts"
export * from "./RiskDisclaimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports